import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DrillsService } from '@drills/infra';

export class DeleteDrillCommandHandler {
  private readonly drillsService: DrillsService = inject(DrillsService);

  execute(drillId: string): Observable<void> {
    return this.drillsService.remove(drillId);
  }
}
